import React from 'react';
import {action} from 'mobx'
import {observer} from 'mobx-react'
import {Button} from 'react-bootstrap'
import CardAttachmentImage from "./CardAttachmentImage";
import BmcCard from "./stores/BmcCard";


@observer
export default class VisionCard extends React.Component {
    constructor(props) {
        super(props);


        this.state = {}
    }

    render() {
        const {blockStore, card} = this.props;

        if (blockStore.filteredCards().find(c => c.name === card.name && c.description === card.description)) {
            return null;
        }

        return (
            <li className="card suggest-card" style={{position: "relative"}}>
                <span className="badge">{card.name}</span>
                <br/>
                <div className="suggest-card-description-container">
                    {card.description}
                    <CardAttachmentImage attachments={card.attachments}/>
                </div>
                &nbsp;
                <Button bsStyle="default" bsSize="small" className="negative-top-right"
                        onClick={this.addCard}
                >
                    <i className="fa fa-plus" aria-hidden="true"/>
                </Button>
            </li>
        );
    }

    @action
    addCard = () => {
        const {blockStore, card} = this.props;
        // const {id, name, description,} = card;
        // const newCard = new BmcCard(blockStore, {
        //     name: card.name,
        //     description: card.description,
        //     attachments: card.attachments
        // }, false);

        const newCard = new BmcCard(blockStore, card, false);
        blockStore.addCloneCard(newCard)
        // blockStore.addCard(newCard)

    };
}

